import script from "./ViewAndShiftsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAndShiftsTable.vue?vue&type=script&setup=true&lang=js"

import "./ViewAndShiftsTable.vue?vue&type=style&index=0&id=73b18c76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b18c76"]])

export default __exports__